





import { Component, Vue } from 'vue-property-decorator'
import {MDCRipple} from '@material/ripple'
@Component({})
export default class MdcButton extends Vue{
  ripple!:MDCRipple
  mounted() {
    const root =(this.$refs.root as Element)
    this.ripple = new MDCRipple(root)
  }
  beforeDestroy() {
    this.ripple.destroy()
  }
}
